/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Section_TriggersInputs */

const cs_automation_section_triggers = /** @type {(inputs: Automation_Section_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggery`)
};

const en_automation_section_triggers = /** @type {(inputs: Automation_Section_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggers`)
};

/**
* | output |
* | --- |
* | "Triggers" |
*
* @param {Automation_Section_TriggersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_section_triggers = /** @type {((inputs?: Automation_Section_TriggersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Section_TriggersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_section_triggers(inputs)
	return cs_automation_section_triggers(inputs)
});